/* QR検索モーダル */
import React, { memo } from 'react';
import { Col, Modal, Button } from 'react-bootstrap';
var ReadQrcodeModalConfirm = function (_a) {
    var show = _a.show, value = _a.value, handleClickQrcodeSearch = _a.handleClickQrcodeSearch, handleChangeQrcode = _a.handleChangeQrcode;
    return (React.createElement(Modal, { id: "read-qrcode", size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null),
        React.createElement(Modal.Body, { className: "dialog-body" },
            React.createElement("p", null,
                "QR\u30B3\u30FC\u30C9\u306E\u8AAD\u307F\u8FBC\u307F\u3092\u884C\u3063\u3066\u3001\u300C\u691C\u7D22\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u4E0B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                React.createElement("br", null),
                "\u8A72\u5F53\u30C7\u30FC\u30BF\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u30A8\u30E9\u30FC\u3068\u306A\u308A\u307E\u3059\u3002"),
            React.createElement(Col, { md: 12 },
                React.createElement("input", { type: "text", className: 'search-form-input maximum', onChange: handleChangeQrcode, value: value }))),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "main-color", onClick: handleClickQrcodeSearch }, "\u691C\u7D22"))));
};
export default memo(ReadQrcodeModalConfirm);
